import {reactive} from 'petite-vue'

const submitBtn = document.querySelector('.submit-btn');

export default function ContactForm() {
  return {
    loading: reactive(false),
    data: {},
    async submitForm(e) {

      const formData = new FormData(e.target)

      this.loading = true;
      const myHeaders = new Headers();
      try {
        const res = await fetch('/services/post/', {
          method: 'POST',
          headers: myHeaders,
          body: formData,
          redirect: 'follow'
        })
        const data = await res.json();
        submitBtn.disabled = true;

        this.loading = false;
        this.data = {...data, done: true};
        e.target.reset()
      }
      catch (error) {
        this.loading = false;
        console.log('error', error);
      }
    },

  }
}


